module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audioCustomizer"
  }, [_c('div', {
    staticClass: "commonParameters"
  }, [_c('div', {
    staticClass: "field is-horizontal locale"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.language')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.commonParameters.locale),
      expression: "scenario.parameters.commonParameters.locale"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Locale"
    },
    domProps: {
      "value": (_vm.scenario.parameters.commonParameters.locale)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters.commonParameters, "locale", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal vendor"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.voiceParameters.vendor),
      expression: "scenario.parameters.voiceParameters.vendor"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.scenario.parameters.voiceParameters, "vendor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "yandex"
    }
  }, [_vm._v("Yandex")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "azure"
    }
  }, [_vm._v("Azure")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal voice"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.voice')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.voiceParameters.voiceName),
      expression: "scenario.parameters.voiceParameters.voiceName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "voiceName"
    },
    domProps: {
      "value": (_vm.scenario.parameters.voiceParameters.voiceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters.voiceParameters, "voiceName", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', [_vm._l((_vm.scenario.parameters.audio), function(answer) {
    return _c('div', {
      staticClass: "answer_shell"
    }, [_c('answer', {
      attrs: {
        "answer-title": answer.title,
        "answer-theme": answer.name,
        "answer-words": _vm.generateWords(answer),
        "answer-audio": answer.sounds,
        "answer-text": answer.text,
        "answer-vendor": _vm.scenario.parameters.voiceParameters.vendor,
        "answer-locale": _vm.scenario.parameters.commonParameters.locale,
        "answer-speaker": _vm.scenario.parameters.voiceParameters.voiceName,
        "answer-emotion": answer.emotion,
        "answer-speed": answer.speed,
        "is-saved": true,
        "client": _vm.scenario.client,
        "scenario-id": _vm.scenario.id
      },
      on: {
        "update:answerAudio": function($event) {
          return _vm.$set(answer, "sounds", $event)
        },
        "update:answer-audio": function($event) {
          return _vm.$set(answer, "sounds", $event)
        },
        "update:answerText": function($event) {
          return _vm.$set(answer, "text", $event)
        },
        "update:answer-text": function($event) {
          return _vm.$set(answer, "text", $event)
        },
        "update:answerVendor": function($event) {
          return _vm.$set(_vm.scenario.parameters.voiceParameters, "vendor", $event)
        },
        "update:answer-vendor": function($event) {
          return _vm.$set(_vm.scenario.parameters.voiceParameters, "vendor", $event)
        },
        "update:answerLocale": function($event) {
          return _vm.$set(_vm.scenario.parameters.commonParameters, "locale", $event)
        },
        "update:answer-locale": function($event) {
          return _vm.$set(_vm.scenario.parameters.commonParameters, "locale", $event)
        },
        "update:answerSpeaker": function($event) {
          return _vm.$set(_vm.scenario.parameters.voiceParameters, "voiceName", $event)
        },
        "update:answer-speaker": function($event) {
          return _vm.$set(_vm.scenario.parameters.voiceParameters, "voiceName", $event)
        },
        "update:answerEmotion": function($event) {
          return _vm.$set(answer, "emotion", $event)
        },
        "update:answer-emotion": function($event) {
          return _vm.$set(answer, "emotion", $event)
        },
        "update:answerSpeed": function($event) {
          return _vm.$set(answer, "speed", $event)
        },
        "update:answer-speed": function($event) {
          return _vm.$set(answer, "speed", $event)
        },
        "generateAudioHandler": _vm.setAudio,
        "deleteAudioHandler": _vm.deleteAudio
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.scenario.parameters.sms), function(sms) {
    return _c('div', {
      staticClass: "sms_shell"
    }, [_c('sms', {
      attrs: {
        "sms-title": sms.title,
        "sms-theme": sms.name,
        "sms-text": sms.text,
        "is-saved": true
      },
      on: {
        "update:smsText": function($event) {
          return _vm.$set(sms, "text", $event)
        },
        "update:sms-text": function($event) {
          return _vm.$set(sms, "text", $event)
        }
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "scenarioBarShell"
  }, [_c('tool-buttons', {
    attrs: {
      "name": _vm.name,
      "scenario": _vm.scenario,
      "campaign-id": _vm.campaignid
    },
    on: {
      "update:scenario": function($event) {
        _vm.scenario = $event
      },
      "set": _vm.setScenario,
      "setDefault": _vm.setScenario
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Generation vendor")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4493c831"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/audioCustomizer/AudioCustomizer.vue
// module id = 650
// module chunks = 42